import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import { Col, Row, Card, CardBody, Button } from 'reactstrap'
import BasicTable from '../../../../components/BasicTable/BasicTable'
import { openAlert } from '../../../../store/actions'
import LoopPieChart from '../../LoopPieChart/LoopPieChart'
// import { changePriceAlertsQueryObject, changeTestsQueryObject, clearPriceAlerts, getPriceAlerts, getTests, openAlert } from '../../../../store/actions'
// import PriceAlertsTableColumns from '../../../Offers/PriceAlerts/PriceAlertsTableColumns'
import LoopReChart from '../../LoopReChart/LoopReChart'
import { ColorsPaletteLoop, ColorsPalette, ColorsPalette2, ColorsPaletteArray, ColorsPaletteArray3 } from '../../Dashboard'
import { capitalize } from 'lodash'
import { getRetailersAddedToWardrobeLineChartStats, getRetailersWardrobesPieChartsStats } from '../../../../helpers/backend_helper'
import moment from "moment-timezone"
import { demoProductsAddedByPlugin } from './DemoStatsData'
import ReactDatePicker from 'react-datepicker'

interface Props {
    t: (text: string) => string
}

const WardrobesStatsTab = ({ t }: Props) => {
    const history = useHistory();
    const dispatch = useDispatch();
    
    const userEmail = useSelector((state: any) => state?.Account?.user?.email)

    // ROW 1
    const [wardrobeProductsByAge, setWardrobeProductsByAge] = useState<any>([]);
    const [wardrobeProductsByPrice, setWardrobeProductsByPrice] = useState<any>([]);
    const [wardrobeProductsByGender, setWardrobeProductsByGender] = useState<any>([])
    // ROW 2
    const [wardrobeProductsByCategory, setWardrobeProductsByCategory] = useState<any>([])

    const [pieChartsData, setPieChartsData] = useState({
        brands_counts: [],
        category_counts: [],
        gender_counts: [],
        price_ranges: [],
    });

    const getPieChartsStats = async (page = 1, queryObject?: any) => {
        try {
            //   const params = new URLSearchParams(queryObject ?? {})
            const response = await getRetailersWardrobesPieChartsStats(true)
            setPieChartsData(response)

            setWardrobeProductsByAge([
                // { name: '0-13 yrs', value: 50, color: ColorsPalette2.blue },
                { name: 'under 18 yrs', value: response?.age_groups[0]?.doc_count, color: ColorsPalette2.orange },
                { name: '18-24 yrs', value: response?.age_groups[1]?.doc_count, color: ColorsPalette2.redOrange },
                { name: '25-30 yrs', value: response?.age_groups[2]?.doc_count, color: ColorsPalette2.lightGreen },
                { name: '31-40 yrs', value: response?.age_groups[3]?.doc_count, color: ColorsPalette2.lavender },
                { name: '41-50 yrs', value: response?.age_groups[4]?.doc_count, color: ColorsPalette.darkBlue },
                { name: '60+ yrs', value: response?.age_groups[5]?.doc_count, color: ColorsPalette.bottleGreen },
            ])

            setWardrobeProductsByGender(
                response?.gender_counts
                    ?.map((stat: any) => {
                        return {
                            name: capitalize(stat.key), 
                            value: stat.doc_count,
                            color: stat.key === 'women' ? ColorsPaletteLoop.loopPink : ColorsPaletteLoop.loopBlue
                        }
                    })
            )

            setWardrobeProductsByPrice([
                { name: '£0-10', value: response?.price_ranges[0]?.doc_count, color: ColorsPalette.orange },
                { name: '£11-20', value: response?.price_ranges[1]?.doc_count, color: ColorsPalette.yellow },
                { name: '£21-30', value: response?.price_ranges[2]?.doc_count, color: ColorsPalette.darkGreen },
                { name: '£30+', value: response?.price_ranges[3]?.doc_count, color: ColorsPalette.appleGreen },
            ])

            // let index = 0
            // arr?.map((x) => {
            //     if(index === Object?.values(ColorsPalette)?.length){
            //         index = 0
            //     }
            //     console.log(Object?.values(ColorsPalette)[index])
            //     index++
            // })

            let index = 0
            setWardrobeProductsByCategory(
                response?.category_counts?.map((cat: any) => {
                    //wyzeruj index gdy skończą się kolory w ColorsPalette
                    if(index === Object?.values(ColorsPalette)?.length){
                        index = 0
                    }
                    const obj = {
                        name: cat?.key,
                        value: cat?.doc_count,
                        color: Object?.values(ColorsPalette)[index]
                    }
                    index++;
                    return obj
                })
                // [
                //     { name: 'Tops', value: 550, color: ColorsPalette.appleGreen },
                //     { name: 'Bottoms', value: 400, color: ColorsPalette.blue },
                //     { name: 'Outerwear', value: 320, color: ColorsPalette.bottleGreen },
                //     { name: 'Shoes', value: 100, color: ColorsPalette.darkGreen },
                //     { name: 'Bags', value: 150, color: ColorsPalette.darkBlue },
                //     { name: 'Accessories', value: 200, color: ColorsPalette.blue },
                //     { name: 'Beauty', value: 200, color: ColorsPalette2.redOrange },
                // ]
            );
     
     
            //     (prev: any) => {
        //     return prev?.map((x: any) => {
        //       x.customLength = response[x.key]
        //       return x;
        //     })
        //   })
        } catch (error) {
    
        }
    }
    
    // const getProductsAddedByPlugin = async (page = 1, queryObject?: any) => {
    //     try {
    //         //   const params = new URLSearchParams(queryObject ?? {})
    //         const response = await getRetailersAddedToWardrobeLineChartStats(true)

    //         setProductsAddedByPlugin([
    //             {date: '2023-01-01', added: 22 },
    //             {date: '2023-01-02', added: 15 },
    //             {date: '2023-01-03', added: 17 },
    //             {date: '2023-01-04', added: 16 },
    //             {date: '2023-01-05', added: 25 },
    //             {date: '2023-01-06', added: 24 },
    //             {date: '2023-01-07', added: 34 },
    //         ])
         
    //     } catch (error) {
    
    //     }
    // }

    const[productsAddedByPlugin, setProductsAddedByPlugin] = useState<any>({
        stats: []
    });
    const getProductsAddedByPlugin = async (queryObject = {}) => {
        try {
            const params = new URLSearchParams({...(queryObject ?? {}), field: 'clicks' })

            //default from 2025-01-01 to today
            if(!(params.get("period_from") && params.get("period_to"))){
                params.set("period_from", "2025-01-01")
                params.set("period_to", moment(new Date())?.format("YYYY-MM-DD"))
            }

            const response = await getRetailersAddedToWardrobeLineChartStats(true, params?.toString())
            let formatted = { ...response };
            if(response?.type === "day"){
                formatted.stats = response?.stats?.map((stat: any) => {
                    stat.formatted_period = stat.period.from;
                    return stat;
                })
            }else if(response?.type === "week"){
                // let weekCounter = 1;
                // let prevMonth = "";
                // let currentMonth = null;
                // formatted.stats = response?.stats?.map((stat: any) => {
                //     currentMonth = moment(stat.period.to)?.format("MM")
                //     if(currentMonth !== prevMonth){
                //         weekCounter = 1;
                //     }else{
                //         weekCounter += 1;
                //     }
                //     prevMonth = moment(stat.period.to)?.format("MM")
                //     stat.formatted_period = moment(stat.period.to)?.format("YYYY.MM") + `.W${weekCounter}`
                //     return stat;
                // })
                // let weekCounter = 1;
                // let prevMonth = "";
                // let currentMonth = null;
                formatted.stats = response?.stats?.map((stat: any) => {
                    let currentDay = parseInt(moment(stat.period.to)?.format("DD"));
                    let currentWeek = Math.ceil(currentDay/7)
                    // prevMonth = moment(stat.period.to)?.format("MM")
                    stat.formatted_period = moment(stat.period.to)?.format("YYYY.MM") + `.W${currentWeek}`
                    return stat;
                })
            }else if(response?.type === "month"){
                formatted.stats = response?.stats?.map((stat: any) => {
                    stat.formatted_period = moment(stat.period.from)?.format("YYYY.MM")
                    return stat;
                })
            }else if(response?.type === "year"){
                formatted.stats = response?.stats?.map((stat: any) => {
                    stat.formatted_period = moment(stat.period.from)?.format("YYYY")
                    return stat;
                })
            }

            setProductsAddedByPlugin(formatted)
            console.log(formatted)
        } catch (error) {

        }
    }
    
    useEffect(() => {
        if(userEmail === "demo@loop.com"){
            setDemoStats()
        }else{
            getPieChartsStats()
            getProductsAddedByPlugin()
        }
    }, [])

    const setDemoStats = () => {
        setWardrobeProductsByAge([
            // { name: '0-13 yrs', value: 50, color: ColorsPalette2.blue },
            { name: 'under 18 yrs', value: 50, color: ColorsPalette2.orange },
            { name: '18-24 yrs', value: 350, color: ColorsPalette2.redOrange },
            { name: '25-30 yrs', value: 300, color: ColorsPalette2.lightGreen },
            { name: '31-40 yrs', value: 150, color: ColorsPalette2.lavender },
            { name: '41-50 yrs', value: 100, color: ColorsPalette.darkBlue },
            { name: '60+ yrs', value: 50, color: ColorsPalette.bottleGreen },
        ])
        setWardrobeProductsByGender([
            { name: 'Men', value: 400, color: ColorsPaletteLoop.loopBlue },
            { name: 'Women', value: 600 , color: ColorsPaletteLoop.loopPink },
        ])

        setWardrobeProductsByPrice([
            { name: '£0-10', value: 400, color: ColorsPalette.orange },
            { name: '£11-20', value: 100, color: ColorsPalette.yellow },
            { name: '£21-30', value: 300, color: ColorsPalette.darkGreen },
            { name: '£30+', value: 200, color: ColorsPalette.appleGreen },
        ])

        setWardrobeProductsByCategory([
            // { name: 'Clothes', value: 400, color: ColorsPalette.orange },
            { name: 'Tops', value: 550, color: ColorsPalette.appleGreen },
            { name: 'Bottoms', value: 400, color: ColorsPalette.blue },
            { name: 'Outerwear', value: 320, color: ColorsPalette.bottleGreen },
            { name: 'Shoes', value: 100, color: ColorsPalette.darkGreen },
            { name: 'Bags', value: 150, color: ColorsPalette.darkBlue },
            { name: 'Accessories', value: 200, color: ColorsPalette.blue },
            { name: 'Beauty', value: 200, color: ColorsPalette2.redOrange },
        ]);

        setProductsAddedByPlugin(demoProductsAddedByPlugin)
    }

    const [dateRange, setDateRange] = useState<any>([null, null]);
    const [startDate, endDate] = dateRange;
    const [allowClear, setAllowClear] = useState(false);
    const [queryObject, setQueryObject] = useState<any>({});
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        handleDatePicker()
      }, [startDate, endDate])

    const handleDatePicker = async () => {
        if(startDate && endDate){
            const customFilters = {
              period_from: moment(startDate).format('YYYY-MM-DD'),
              period_to: moment(endDate).format('YYYY-MM-DD')
            }
          //   customFilters.sort = customFilters.sort?.replace("totals", "period_counts")
          
            setIsLoading(true)
            await Promise.all([
                // getMostViewedFeedItems(1, { sort: "stats.totals.views"?.replace("totals", "period_counts"), direction: 'desc', ...customFilters }),
                // getMostClickedFeedItems(1, { sort: "stats.totals.clicks"?.replace("totals", "period_counts"), direction: 'desc', ...customFilters }),
                // getFeedItemsClicks(customFilters),
                getProductsAddedByPlugin(customFilters)
            ])
            setIsLoading(false)

            setAllowClear(true)

            const params = new URLSearchParams(location?.search)
            params.set("period_from", moment(startDate)?.format("YYYY-MM-DD"))
            params.set("period_to", moment(endDate)?.format("YYYY-MM-DD"))
            history?.replace(`${location?.pathname}?${params?.toString()}`)
      
        }else if(allowClear && startDate === null && endDate === null){
            // const customFilters = { ...queryObject }
            // delete customFilters.period_from
            // delete customFilters.period_to
            // customFilters.sort = customFilters.sort?.replace("period_counts", "totals")

            setIsLoading(true)
            await Promise.all([
                // getMostViewedFeedItems(1, { sort: "stats.totals.views"?.replace("period_counts", "totals"), direction: 'desc' }),
                // getMostClickedFeedItems(1, { sort: "stats.totals.clicks"?.replace("period_counts", "totals"), direction: 'desc' }),
                // getFeedItemsClicks(),
                getProductsAddedByPlugin()
            ])
            setIsLoading(false)

            const params = new URLSearchParams(location?.search)
            params.delete("period_from")
            params.delete("period_to")
            history?.replace(`${location?.pathname}?${params?.toString()}`)
        }
    }

    return (
        <div className="add-to-stats-tab">
            {/* ROW 1 */}
            <Row>
                <Col sm={12} md={12} lg={12} xl={4}>
                    <Card className="w-100">
                        <CardBody className="p-3">
                            <h4 className="card-title" style={{marginTop: 15, marginBottom: 16}}>{t("Products separated into the age of the user")}</h4>
                            <LoopPieChart
                                data={wardrobeProductsByAge}
                            />
                        </CardBody>
                    </Card>
                </Col>
                <Col sm={12} md={12} lg={12} xl={4}>
                    <Card className="w-100">
                        <CardBody className="p-3">
                            <h4 className="card-title" style={{marginTop: 15, marginBottom: 16}}>{t("Products separated by average price")}</h4>
                            <LoopPieChart 
                                data={wardrobeProductsByPrice}
                            />
                        </CardBody>
                    </Card>
                </Col>
                <Col sm={12} md={12} lg={12} xl={4}>
                    <Card className="w-100">
                        <CardBody className="p-3">
                            <h4 className="card-title" style={{marginTop: 15, marginBottom: 16}}>Products by gender</h4>
                            <LoopPieChart 
                                data={wardrobeProductsByGender}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>

            {/* ROW 2 */}
            <Row>
                <Col sm={12} md={12} lg={12} xl={4}>
                    <Card className="w-100">
                        <CardBody className="p-3">
                            <h4 className="card-title" style={{marginTop: 15, marginBottom: 16}}>{t("Products separated into categories")}</h4>
                            <LoopPieChart 
                                data={wardrobeProductsByCategory}
                            />
                        </CardBody>
                    </Card>
                </Col>
                <Col sm={8}>
                    <Card>
                        <CardBody className="p-3">
                            {/* <h4 className="card-title" style={{marginTop: 15, marginBottom: 16}}>{t("Daily chart showing the number of products added to wardrobes through the use of the plugin")}</h4>
                            <LoopReChart
                                height={300}
                                data={productsAddedByPlugin}
                                showLoaderOnEmptyData={true}
                                xAxisDataKey="date"
                                lines={[
                                    // { type: "monotone", dataKey: "new", name: "New", stroke: "#4d9de0", activeDotSize: 5 },
                                    { type: "linear", dataKey: "added", name: "Added", stroke: ColorsPaletteLoop.green, activeDotSize: 5, label: { dataKey: "added" } },
                                    // { type: "monotone", dataKey: "total", name: "Total", stroke: "#e15554", activeDotSize: 8 },
                                ]}
                            /> */}
                            <div className='d-flex justify-content-between flex-wrap mb-2'>
                                <h4 className="card-title mb-1" style={{marginTop: 15, marginBottom: 16}}>
                                    {t("Number of products added to wardrobes through the use of the plugin")} {productsAddedByPlugin?.type === "day" ? "DAI" : productsAddedByPlugin?.type?.toUpperCase()}LY
                                    <small className='ms-1 text-muted fw-normal'>
                                        {startDate && endDate
                                            ? (
                                                moment(startDate)?.format("DD-MM-YYYY") === moment(endDate)?.format("DD-MM-YYYY") 
                                                    ? `(${moment(startDate)?.format("DD-MM-YYYY")})`
                                                    : `(${moment(startDate)?.format("DD-MM-YYYY")} - ${moment(endDate)?.format("DD-MM-YYYY")})`
                                            ): `(IN TOTAL)`
                                        }
                                    </small>
                                </h4>
                                <div className='w-25'>
                                    <ReactDatePicker
                                        selectsRange={true}
                                        startDate={startDate}
                                        endDate={endDate}
                                        onChange={(update) => {
                                            setDateRange(update);
                                        }}
                                        className="form-control"
                                        calendarClassName="react-datepicker"
                                        dateFormat="dd-MM-yyyy"
                                        maxDate={new Date()}
                                        shouldCloseOnSelect={startDate && !endDate}
                                        isClearable={true}
                                        placeholderText={t("Pick a date range")}
                                    />
                                </div>
                            </div>
                            <LoopReChart
                                height={300}
                                data={productsAddedByPlugin?.stats}
                                showLoaderOnEmptyData={true}
                                xAxisDataKey="formatted_period"
                                dataMaxKey="value"
                                tooltipFormatter={(label, payload) => {
                                    // console.log(label, payload)
                                    if(productsAddedByPlugin?.type === "week"){
                                        const statData = payload?.[0]?.payload;
                                        return label + ` (${statData?.period?.from?.replaceAll("-", ".")}-${statData?.period?.to?.replaceAll("-", ".")})`
                                    }else{
                                        return label
                                    }
                                }}
                                lines={[
                                    // { type: "monotone", dataKey: "new", name: "New", stroke: "#4d9de0", activeDotSize: 5 },
                                    { type: "linear", dataKey: "value", name: "Clicks", stroke: ColorsPaletteLoop.green, activeDotSize: 5, label: { dataKey: "value" } },
                                    // { type: "monotone", dataKey: "total", name: "Total", stroke: "#e15554", activeDotSize: 8 },
                                ]}
                            />
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </div>
    )
}

export default WardrobesStatsTab
